<template>
  <span
    class="
      content-badge
      text-other-label-s
      text-other-label-l-desktop
    "
    :class="[
      `content-badge--${colorScheme}`,
      `content-badge--${template}`,
      {
        'content-badge--is-small': isSmall,
        'content-badge--text-hover': isTextHover,
        [$class('active')]: isActive
      }
    ]"
  >
    <span
      class="content-badge__icon"
      aria-hidden="true"
    >
      <slot name="icon" />
    </span>

    <span
      class="content-badge__text"
    >
      <span
        class="content-badge__text-inner"
        v-html="badgeText"
      />
    </span>
  </span>
</template>

<script>

/**
 * Vue: Content badge (content-badge)
 * -----------------------------------------------------------------------------
 * Content badge overlayed over product image or variant pills.
 *
 * @param {String} badgeText - Badge text to display.
 * @param {String} [colorScheme] - Custom colour scheme.
 * @param {Boolean} [isActive] - If parent element has mouse/keyboard focus.
 * @param {Boolean} [isSmall] - Use smaller styles.
 * @param {String} [isTextHover] - If the text should appear on hover.
 * @param {String} [template] - Visual design of badge.
 */

export default {
  name: 'ContentBadge',

  props: {
    badgeText: {
      type: String,
      default: '',
      required: true,
    },
    colorScheme: {
      type: String,
      default: 'yellow',
      validator: (value) => {
        return ['dark-grey', 'grey', 'yellow'].includes(value)
      },
    },
    isActive: {
      type: Boolean,
      default: false,
    },
    isSmall: {
      type: Boolean,
      default: false,
    },
    isTextHover: {
      type: Boolean,
      default: false,
    },
    template: {
      type: String,
      default: 'floating',
      validator: (value) => {
        return ['floating', 'sticker'].includes(value)
      },
    },
  },
}
</script>

<style lang="scss">
@import './content-badge';
</style>
